import styled from 'styled-components';

export const RadioContainer = styled.div`
  display: flex;
  flex-direction: column;
  & > label, & > small {
    margin-bottom: 10px;
  }
`;